import { useAtom, useAtomValue } from "jotai";
import {
  currentWorkspaceAtom,
  workspaceLoadingAtom,
  workspaceErrorAtom,
  setWorkspaceAtom,
  workspaceHasWorkspaceAtom,
  workspaceSettingsAtom,
  workspaceUserRoleNamesAtom,
} from "@/store/workspace";
import { WorkSpace, WorkSpaceSettings } from "@/core/entities/workspace";

interface UseWorkspace {
  workspace: WorkSpace | null;
  settings: WorkSpaceSettings | null;
  userRoleNames: string[];
  isLoading: boolean;
  error: Error | null;
  hasWorkspace: boolean;
  setWorkspace: () => Promise<void>;
}

export function useWorkspace(): UseWorkspace {
  // Read-only atoms
  const hasWorkspace = useAtomValue(workspaceHasWorkspaceAtom);
  const workspace = useAtomValue(currentWorkspaceAtom);
  const settings = useAtomValue(workspaceSettingsAtom);
  const userRoleNames = useAtomValue(workspaceUserRoleNamesAtom);
  const isLoading = useAtomValue(workspaceLoadingAtom);
  const error = useAtomValue(workspaceErrorAtom);

  // Action atoms
  const [, setWorkspace] = useAtom(setWorkspaceAtom);

  return {
    // State
    workspace,
    settings,
    userRoleNames,
    isLoading,
    error,
    hasWorkspace,

    // Actions
    setWorkspace,
  };
}
